<template>
    <div>
    <div v-if="!number">
         <login />
    </div>
    <div v-if="number">    
         <div class="page-template-pricing">
         <div class="section-pricing">
            <div class="container">
            
               <div class="row pricing-f">
                  <div class="col-md-12">
                     <h2>Planejamento Colaborativo 2022-2025</h2>
                  </div>
               </div>
               <div class="row pricing-f-b align-items-start p-3 pt-5" style="background: #04182d;">
                  <div class="col-md-6 col-sm-4 wow fadeIn" data-wow-delay="0.2s">
                     <div class="feature">
                        <div > <!-- class="feature_icon" -->
                          <!-- <img src="../imagess/pricing_icon_1.png" alt=""> -->
                          <img src="../imagess/2.jpeg"  alt="" class="mb-3">

                        </div>
                        
						<CButton v-if="!perguntas.administracaoegestao" class="getselectedprimary" to="/administracao-e-gestao">Participar</CButton>
                  <CButton v-if="perguntas.administracaoegestao" class="getselectedsuccess" to="/administracao-e-gestao">Obrigado por participar</CButton>
                     </div>
					 
                  </div>
                  <div class="col-md-6 col-sm-4 wow fadeIn" data-wow-delay="0.4s">
                     <div class="feature">
                        <div >
                           <img src="../imagess/1.jpeg"  alt="" class="mb-3">
                        </div>
                        
						<CButton v-if="!perguntas.assistenciasocial" class="getselectedprimary" to="/assistencia-social">Participar</CButton>
                  <CButton v-if="perguntas.assistenciasocial" class="getselectedsuccess" to="/assistencia-social">Obrigado por participar</CButton>
                     </div>
                  </div>
                  <div class="col-md-6 col-sm-4 wow fadeIn" data-wow-delay="0.2s">
                     <div class="feature">
                        <div >
                           <img src="../imagess/5cult.jpeg"  alt="" class="mb-3">
                        </div>
                        
						<CButton v-if="!perguntas.cultura" class="getselectedprimary" to="/cultura">Participar</CButton>
                  <CButton v-if="perguntas.cultura" class="getselectedsuccess" to="/cultura">Obrigado por participar</CButton>
                     </div>
                  </div>
                  <div class="col-md-6 col-sm-4 wow fadeIn" data-wow-delay="0.6s">
                     <div class="feature">
                        <div >
                          <img src="../imagess/3.jpeg"  alt="" class="mb-3">
                        </div>
                        
						<CButton v-if="!perguntas.desenvolvimentoeconomico" class="getselectedprimary" to="/desenvolvimento-economico">Participar</CButton>
                  <CButton v-if="perguntas.desenvolvimentoeconomico" class="getselectedsuccess" to="/desenvolvimento-economico">Obrigado por participar</CButton>
                     </div>
                  </div>
                  <div class="col-md-6 col-sm-4 wow fadeIn" data-wow-delay="0.2s">
                     <div class="feature">
                        <div >
                           <img src="../imagess/5edu.jpeg"  alt="" class="mb-3">
                        </div>
                        
						<CButton v-if="!perguntas.educacao" class="getselectedprimary" to="/educacao">Participar</CButton>
                  <CButton v-if="perguntas.educacao" class="getselectedsuccess" to="/educacao">Obrigado por participar</CButton>
                     </div>
                  </div>
                  
                  <div class="col-md-6 col-sm-4 wow fadeIn" data-wow-delay="0.2s">
                     <div class="feature">
                        <div >
                           <img src="../imagess/5esport.jpeg"  alt="" class="mb-3">
                        </div>
                        
						<CButton v-if="!perguntas.esporteelazer" class="getselectedprimary" to="/esporte-e-lazer">Participar</CButton>
                  <CButton v-if="perguntas.esporteelazer" class="getselectedsuccess" to="/esporte-e-lazer">Obrigado por participar</CButton>
                     </div>
                  </div>
                  <div class="col-md-6 col-sm-4 wow fadeIn" data-wow-delay="0.4s">
                     <div class="feature">
                        <div >
                           <img src="../imagess/7.jpeg"  alt="" class="mb-3">
                        </div>
                        
						<CButton v-if="!perguntas.governoecomunicacaosocial" class="getselectedprimary" to="/governo-e-comunicacao-social">Participar</CButton>
                  <CButton v-if="perguntas.governoecomunicacaosocial" class="getselectedsuccess" to="/governo-e-comunicacao-social">Obrigado por participar</CButton>
                     </div>
                  </div>
                  <div class="col-md-6 col-sm-4 wow fadeIn" data-wow-delay="0.6s">
                     <div class="feature">
                        <div >
                           <img src="../imagess/8.jpeg"  alt="" class="mb-3">
                        </div>
                        
						<CButton v-if="!perguntas.obras" class="getselectedprimary" to="/obras-servicos-urbanos-mobilidade-e-habitacao">Participar</CButton>
                  <CButton v-if="perguntas.obras" class="getselectedsuccess" to="/obras-servicos-urbanos-mobilidade-e-habitacao">Obrigado por participar</CButton>
                     </div>
                  </div>
                  <div class="col-md-6 col-sm-4 wow fadeIn" data-wow-delay="0.2s">
                     <div class="feature">
                        <div >
                           <img src="../imagess/4.jpeg"  alt="" class="mb-3">
                        </div>
                        
						<CButton v-if="!perguntas.planejamento" class="getselectedprimary" to="/planejamento-urbanismo-e-meio-ambiente">Participar</CButton>
                  <CButton v-if="perguntas.planejamento" class="getselectedsuccess" to="/planejamento-urbanismo-e-meio-ambiente">Obrigado por participar</CButton>
                     </div>
                  </div>
                  <div class="col-md-6 col-sm-4 wow fadeIn" data-wow-delay="0.4s">
                     <div class="feature">
                        <div >
                           <img src="../imagess/6.jpeg"  alt="" class="mb-3">
                        </div>
                        
						<CButton v-if="!perguntas.saude" class="getselectedprimary" to="/saude">Participar</CButton>
                  <CButton v-if="perguntas.saude" class="getselectedsuccess" to="/saude">Obrigado por participar</CButton>
                     </div>
                  </div>
<!--                  <div class="col-md-4 col-sm-4 wow fadeIn" data-wow-delay="0.6s">
                     <div class="feature">
                        <div class="feature_icon">
                           <img src="../imagess/pricing_icon_3.png" alt="">
                        </div>
                        <h3>Support </h3>
                        <p class="feature_text">The wise man therefore always holds in these matters to this principle of selection: 
                           he rejects pleasures to secure other greater pleasures, or else he endures pains 
                           to avoid worse pains.
                        </p>
						<a class="getselected" href="#">Get contact</a>
                     </div>
                  </div>
-->
               </div>
            </div>
         </div>
      </div>  
    </div>
            
    </div>
</template>

<script>
import firebase from 'firebase'
import login from '@/components/Verificacao.vue'

export default {
    name: 'Perguntas',
    components: {
    login,   
  }, 
    data () {
    return {         
         phoneNumber:null,
         number: null,
         administra: {},                  
         perguntas: {                
                administracaoegestao: false,
                assistenciasocial: false,
                desenvolvimentoeconomico: false,
                educacao: false,
                cultura: false,
                esporteelazer: false,
                governoecomunicacaosocial: false,
                obras: false,
                planejamento: false,
                saude: false                
              },
         campos: [], 
         telefone: []                                          
         }          
      },
      mounted()  {

         this.campos = localStorage.getItem('dadosApp')
         console.log(this.campos)

         let tel = JSON.parse(this.campos)
         let a =  tel
         console.log(a)
         this.telefone1 = a

         console.log(this.telefone1)

         this.number = this.telefone1

         console.log(this.number)
        

        this.$http.get(`${this.number}/resposta/administracaoegestao.json`)
            .then(resposta =>{                                         
                if (resposta.data)                    
                  this.perguntas.administracaoegestao = true 
                  console.log(resposta.data)
                 /*  this.administra = resposta.data                    
                  console.log(this.administra) */
            })
         
         this.$http.get(`${this.number}/resposta/assistenciasocial.json`)
            .then(resposta =>{                                         
                if (resposta.data)                    
                  this.perguntas.assistenciasocial = true 
                  console.log(resposta.data)
                  /* this.administra = resposta.data                    
                  console.log(this.administra) */
            })

         this.$http.get(`${this.number}/resposta/desenvolvimentoeconomico.json`)
            .then(resposta =>{                                         
                if (resposta.data)                    
                  this.perguntas.desenvolvimentoeconomico = true 
                  console.log(resposta.data)
                 /*  this.administra = resposta.data                    
                  console.log(this.administra) */
            })
         
         this.$http.get(`${this.number}/resposta/cultura.json`)
            .then(resposta =>{                                         
                if (resposta.data)                    
                  this.perguntas.cultura = true 
                  console.log(resposta.data)
                 /*  this.administra = resposta.data                    
                  console.log(this.administra) */
            })

         this.$http.get(`${this.number}/resposta/educacao.json`)
            .then(resposta =>{                                         
                if (resposta.data)                    
                  this.perguntas.educacao = true 
                  console.log(resposta.data)
                 /*  this.administra = resposta.data                    
                  console.log(this.administra) */
            })
         this.$http.get(`${this.number}/resposta/esporteelazer.json`)
            .then(resposta =>{                                         
                if (resposta.data)                    
                  this.perguntas.esporteelazer = true 
                  console.log(resposta.data)
                 /*  this.administra = resposta.data                    
                  console.log(this.administra) */
            })
         this.$http.get(`${this.number}/resposta/governoecomunicacaosocial.json`)
            .then(resposta =>{                                         
                if (resposta.data)                    
                  this.perguntas.governoecomunicacaosocial = true 
                  console.log(resposta.data)
                  /* this.administra = resposta.data                    
                  console.log(this.administra) */
            })
         this.$http.get(`${this.number}/resposta/obras.json`)
            .then(resposta =>{                                         
                if (resposta.data)                    
                  this.perguntas.obras = true 
                  console.log(resposta.data)
                 /*  this.administra = resposta.data                    
                  console.log(this.administra) */
            })
         this.$http.get(`${this.number}/resposta/planejamento.json`)
            .then(resposta =>{                                         
                if (resposta.data)                    
                  this.perguntas.planejamento = true 
                  console.log(resposta.data)
                  /* this.administra = resposta.data                    
                  console.log(this.administra) */
            })
         this.$http.get(`${this.number}/resposta/saude.json`)
            .then(resposta =>{                                         
                if (resposta.data)                    
                  this.perguntas.saude = true 
                  console.log(resposta.data)
                  /* this.administra = resposta.data                    
                  console.log(this.administra) */
            })       
    },    
}
</script>

<style scoped>


@import url('https://fonts.googleapis.com/css?family=Raleway:100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i');

/**-- font-family: 'Raleway', sans-serif; --**/


/*------------------------------------------------------------- 
	2. BASE CSS 
-------------------------------------------------------------*/

body {
	font-family: 'Raleway', sans-serif;
	font-weight: 400;
	margin: 0px;
	overflow-x: hidden;
	padding: 0px;
	display: grid;
	grid-gap: 20px;
}

h1,
h2,
h3,
h4,
h5 {
	margin: 0
}

h1,
h2,
h3,
h4,
h5,
h6 {
	margin: 0px;
	padding: 0px;
}

ul,
ol {
	list-style: none;
	margin: 0px;
	padding: 0px;
}

a,
a:hover,
a:focus {
	-webkit-text-decoration: none;
	-moz-text-decoration: none;
	-ms-text-decoration: none;
	-o-text-decoration: none;
	text-decoration: none;
	transition: ease all 0.5s;
}

img {
	max-width: 100%;
	height: auto;
}

input,
textarea {
	outline: none;
	border: none;
	resize: none;
}

/*-- Pricing --*/

.section-pricing {
	background: #07203e;
	background: -moz-linear-gradient(top, #07203e 0, #07223f 8%, #092344 14%, #072442 16%, #0a2445 16%, #082545 23%, #092648 23%, #092847 28%, #0a264b 33%, #0a2749 34%, #0b294b 34%, #0b294b 100%);
	background: -webkit-linear-gradient(top, #07203e 0, #07223f 8%, #092344 14%, #072442 16%, #0a2445 16%, #082545 23%, #092648 23%, #092847 28%, #0a264b 33%, #0a2749 34%, #0b294b 34%, #0b294b 100%);
	background: linear-gradient(to bottom, #07203e 0, #07223f 8%, #092344 14%, #072442 16%, #0a2445 16%, #082545 23%, #092648 23%, #092847 28%, #0a264b 33%, #0a2749 34%, #0b294b 34%, #0b294b 100%);
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#07203e', endColorstr='#0b294b', GradientType=0);
	padding-top: 15px;
	padding-bottom: 25px;
}

.pricing-f h2 {
	font-size: 26px;
	font-weight: 400;
	margin-top: 20px;
	margin-bottom: 25px;
	color: #fff;
}

.feature {
	margin-bottom: 80px;
}

.feature_icon {
	height: 75px;
}

.feature h3 {
	font-size: 20px;
	font-weight: 300;
	line-height: 1;
	margin-bottom: 22px;
	color: #fff;
}

.feature p {
	color: #90a7c2 !important;
	font-size: 14px;
	font-weight: 300;
	line-height: 27px;
}

.getselectedprimary {
    margin-top: 15px;
    font-size: 16px !important;
    font-weight: 500 !important;
    background-color: #1e96ff;
    border-radius: 3px;
    line-height: 45px;
    padding: 0 15px;
    color: #fff;
    text-align: center;
	position: relative;
    z-index: 1;
    display: block;
    height: 100%;
    white-space: nowrap;
}
.getselectedsuccess {
    margin-top: 15px;
    font-size: 16px !important;
    font-weight: 500 !important;
    background-color: #218543;
    border-radius: 3px;
    line-height: 45px;
    padding: 0 15px;
    color: #fff;
    text-align: center;
	position: relative;
    z-index: 1;
    display: block;
    height: 100%;
    white-space: nowrap;
}

@media (max-width: 552px) {
    .pricing-f h2 {
     font-size: 16px;    
     }
}



</style>